const fr = {
  nav: {
    home: "Accueil",
    uploads: "Factures reçues",
    invoices: "Factures",
    sales: "Ventes",
    suppliers: "Fournisseurs",
    clients: "Clients",
    projects: "Projets",
    intervenants: "Intervenants",
    reconciliation: "Réconciliation",
    billing: "Facturation",
    team: "Équipe",
    audit: "Journal d'audit",
    reminderRules: "Règles relances",
    reminderTemplates: "Templates relances",
    company: "Société",
    products: "Produits",
  },
  topbar: {
    tenant: "Tenant",
    chooseTenant: "— choisir —",
    logout: "Déconnexion",
  },
  common: {
    save: "Enregistrer",
    saving: "Enregistrement…",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Éditer",
    create: "Créer",
    search: "Rechercher",
    loading: "Chargement…",
    noData: "Aucune donnée",
    actions: "Actions",
    reset: "Réinitialiser",
    confirm: "Confirmer",
    yes: "Oui",
    no: "Non",
    name: "Nom",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    country: "Pays",
    notes: "Notes",
    total: "Total",
    status: "Statut",
    date: "Date",
    amount: "Montant",
    year: "Année",
    month: "Mois",
    allYears: "Toutes",
    allMonths: "Tous",
    currency: "Devise",
    reference: "Référence",
    download: "Télécharger",
    paid: "Payée",
    pending: "En attente",
    collected: "Encaissé",
    revenue: "CA total",
    invoices: "Factures",
    client: "Client",
    project: "Projet",
    intervenant: "Intervenant",
    description: "Description",
    role: "Rôle",
    active: "Actif",
    inactive: "Inactif",
    add: "Ajouter",
    close: "Fermer",
    previous: "Précédent",
    next: "Suivant",
    noInvoices: "Aucune facture",
    error: "Erreur",
    unknownError: "Erreur inconnue",
  },
  status: {
    draft: "Brouillon",
    issued: "À échoir",
    partial: "Partielle",
    paid: "Payée",
    overdue: "Retard",
    cancelled: "Annulée",
  },
  dashboard: {
    loading: "Chargement du tableau de bord",
    errorLoad: "Impossible de charger le tableau de bord",
    kpiPending: "En attente",
    kpiPendingHint: "TTC restant dû (factures émises non soldées)",
    kpiOverdue: "En retard",
    kpiOverdueHint: "Sous-ensemble des en attente dont l'échéance est passée",
    kpiCollected: "Encaissé ce mois",
    kpiCollectedHint: "Somme des paiements datés du mois en cours",
    activityTitle: "Activité commerciale",
    activitySubtitle: "Facturation TTC par mois (12 derniers mois)",
    activityBilled: "Facturé HT",
    cashflowTitle: "Trésorerie",
    cashflowSubtitle: "Encaissé vs échu par mois",
    cashflowDue: "Attendu",
    cashflowCollected: "Encaissé",
    recentInvoices: "Factures récentes",
    colRef: "Réf.",
    colClient: "Client",
    colProject: "Projet",
    colIntervenant: "Intervenant",
    colDueDate: "Échéance",
    colAmountHT: "Montant HT",
    colStatus: "Statut",
    tenantActive: "Tenant actif",
    roleAdmin: "rôle admin",
    roleMember: "rôle membre",
    hello: "Bonjour",
    sectionClient: "Factures client",
    sectionSupplier: "Factures fournisseur",
    kpiSupplierPending: "À payer (fournisseurs)",
    kpiSupplierPendingHint: "Total TTC des factures fournisseur en attente de paiement",
    kpiSupplierPaid: "Payé ce mois (fournisseurs)",
    kpiSupplierPaidHint: "Somme des paiements fournisseur effectués ce mois",
  
    currencyLabel: "Devise :",
    currencyAll: "Toutes*",
    currencyWarning: "* Les devises ne sont pas consolidées — sélectionne une devise pour voir les KPIs exacts.",
  },
  invoicesPage: {
    title: "Factures",
    subtitle: "Suivi et gestion de toutes vos factures.",
    markPaid: "Marquer payée",
    markPaidTitle: "Marquer comme payée",
    markPaidConfirm: "Confirmer le paiement",
    paymentDate: "Date de paiement",
    newInvoice: "Nouvelle facture",
    open: "Ouvrir",
    filterStatus: "Statut",
    filterClient: "Client",
    filterProject: "Projet",
    filterIntervenant: "Intervenant",
    allStatuses: "Tous les statuts",
    allClients: "Tous les clients",
    allProjects: "Tous les projets",
    allIntervenants: "Tous les intervenants",
    previous: "Précédent",
    next: "Suivant",
    exportXlsx: "Exporter XLSX",
    exporting: "Export…",
    colIssued: "Émise",
    colTTC: "TTC",
    colReste: "Reste",
    issuePeriod: "Période d'émission",
    delete: "Supprimer",
    deleteConfirm: "Supprimer définitivement la facture",
    deleteWarning: "Cette action est irréversible.",
      colRef: "Référence",
      colDue: "Échéance",
      searchPlaceholder: "Rechercher (référence)…",
      reset: "Réinitialiser",
    search: "Rechercher",
    noMatch: "Aucune facture ne correspond à ces critères.",
    loadingList: "Chargement…",
    colClient: "Client",
  },
  invoiceDetail: {
    title: "Facture",
    back: "← Retour au portefeuille",
    backToList: "← Retour à la liste",
    deleteInvoice: "Supprimer cette facture",
    deleteConfirm: "Supprimer cette facture ? Action irréversible.",
    addPayment: "+ Encaissement",
    paymentAmount: "Montant",
    paymentDate: "Date de paiement",
    paymentMethod: "Méthode",
    paymentNote: "Note (optionnelle)",
    paymentRef: "Référence (n° virement, chèque…)",
    paymentConfirm: "Enregistrer le paiement",
    paymentCancel: "Annuler",
    paymentSaving: "Enregistrement…",
    paymentsHistory: "Historique des encaissements",
    noPayments: "Aucun encaissement enregistré pour le moment.",
    sendReminder: "Envoyer une relance",
    generateLink: "Générer un lien de paiement",
    generateZiina: "Générer un lien Ziina",
    regenerateZiina: "Régénérer le lien",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié !",
    generating: "Génération…",
    regenerating: "Régénération…",
    downloadPdf: "Voir le PDF",
    downloadPdfEn: "PDF (EN)",
    downloadPdfFr: "PDF (FR)",
    duplicate: "Dupliquer",
    statusLabel: "Statut",
    amountHT: "Montant HT",
    amountTTC: "Montant TTC",
    dueDate: "Échéance",
    issueDate: "Date d'émission",
    remaining: "Reste à payer",
    totalTtc: "TOTAL TTC",
    collected: "ENCAISSÉ",
    remainingDue: "RESTE DÛ",
    issuedOn: "Émise le",
    dueOn: "Échue le",
    backToDraft: "↩ Remettre en brouillon",
    validateIssue: "✓ Valider et émettre la facture",
    saveDraft: "Enregistrer les modifications",
    saving: "Enregistrement…",
    draftTitle: "Facture brouillon — à compléter",
    draftHint: "Affectez un projet et un intervenant, ajustez le montant si besoin, puis validez.",
    draftProject: "Projet",
    draftNoProject: "— Aucun projet —",
    draftIntervenant: "Intervenant",
    draftNoIntervenant: "— Aucun intervenant —",
    draftDueDate: "Date d'échéance",
    draftCurrency: "Devise",
    draftBilling: "Facturation",
    draftBillingFull: "Totalité du devis",
    draftBillingPercent: "Pourcentage du devis",
    draftBillingQty: "Par quantité (lignes du devis)",
    draftBillingAmount: "Montant personnalisé",
    draftPercent: "Pourcentage à facturer (%)",
    draftAmountHt: "Montant HT (€)",
    draftVat: "TVA (€)",
    draftAmountTtc: "Total TTC (€)",
    notesPlaceholder: "Aucune note pour cette facture.",
    saveNote: "Enregistrer la note",
    paymentLinkTitle: "Lien de paiement en ligne",
    paymentLinkDesc: "Votre client règle la facture par carte via Ziina. Vous pouvez coller le lien dans un email ou le copier depuis ici.",
    paymentLinkNotAvailable: "Cette facture n'est pas dans un état encaissable — pas de lien disponible.",
    paymentLinkUrl: "URL de paiement",
    paymentLinkGeneratedAt: "Généré le",
    paymentLinkExpiresAt: "Expire le",
    paymentLinkExpired: "(expiré)",
    remindersTitle: "Relances",
    remindersSubtitle: "Envois automatiques à J+7, J+14 et J+30 après la date d'échéance.",
    remindersDisabled: "Relances désactivées",
    remindersReason: "Motif :",
    reactivateReminders: "Réactiver les relances",
    disableReminders: "Ne plus relancer",
    noReminders: "Aucune relance envoyée pour le moment.",
    disableReminderTitle: "Ne plus relancer cette facture",
    disableReminderDesc: "Aucune relance automatique ne sera envoyée pour cette facture tant qu'elle reste désactivée. Vous pourrez réactiver à tout moment.",
    disableReminderReason: "Motif (conservé pour l'audit)",
    disableReminderReasonPlaceholder: "Ex : arrangement amiable signé, client en liquidation, doublon…",
    disableReminderConfirm: "Désactiver les relances",
    paymentSuccess: "Merci — le paiement a été confirmé côté Ziina. L'encaissement apparaîtra ici dès réception de la confirmation bancaire.",
    paymentCancelled: "Paiement annulé. Le lien reste valide si vous souhaitez réessayer.",
    close: "Fermer",
    reminderStatusPending: "En attente",
    reminderStatusSent: "Envoyée",
    reminderStatusFailed: "Échec",
    reminderStatusSkipped: "Ignorée",
    paymentMethodBankTransfer: "Virement bancaire",
    paymentMethodCheck: "Chèque",
    paymentMethodCash: "Espèces",
    paymentMethodCard: "Carte bancaire",
    paymentMethodOther: "Autre",
    colDate: "Date",
    colMethod: "Méthode",
    colRef: "Référence",
    colAmount: "Montant",
    loadingError: "Erreur de chargement",
    notFound: "Facture introuvable",
    validating: "Validation en cours…",
    actionImpossible: "Action impossible",
    colRecipient: "Destinataire",
    colTemplate: "Template",
    colStatus: "Statut",
    draftQtyLabel: "Quantités à facturer par ligne",
    draftQtyTotal: "Total TTC calculé :",
    draftPercentTtc: "TTC calculé :",
  },
  clientsPage: {
    title: "Clients",
    subtitle: "Les entités facturées par le tenant actif.",
    newClient: "Nouveau client",
    searchPlaceholder: "Rechercher (nom ou email)…",
    noClients: "Aucun client. Cliquez sur « Nouveau client » pour commencer.",
    deleteConfirm: 'Supprimer le client "{name}" ?',
    editClient: "Éditer le client",
    newClientTitle: "Nouveau client",
    legalName: "Raison sociale",
    siret: "SIRET",
    vatNumber: "N° TVA",
    countryHint: "Ex: FR, AE",
    caByClient: "Répartition du CA par client",
  },
  projectsPage: {
    title: "Projets",
    subtitle: "Regroupez vos factures par projet.",
    newProject: "Nouveau projet",
    noProjects: "Aucun projet.",
    editProject: "Éditer le projet",
    newProjectTitle: "Nouveau projet",
    deleteConfirm: 'Supprimer le projet "{name}" ?',
    caByProject: "Répartition du CA par projet",
    description: "Description",
    nbInvoices: "Factures",
    caTotal: "CA total",
    collected: "Encaissé",
    pending: "En attente",
    filterByClient: "Filtrer par client :",
    allClients: "Tous les clients",
    noClients: "Créez d'abord un client pour pouvoir créer des projets.",
  },
  intervenantsPage: {
    title: "Intervenants",
    subtitle: "Personnes qui réalisent les prestations facturées.",
    newIntervenant: "Nouvel intervenant",
    noIntervenants: "Aucun intervenant.",
    editIntervenant: "Éditer l'intervenant",
    newIntervenantTitle: "Nouvel intervenant",
    deleteConfirm: 'Supprimer l\'intervenant "{name}" ?',
    caByIntervenant: "Répartition du CA par intervenant",
    active: "Actifs",
    inactive: "Inactifs",
    activeOnly: "Actifs seulement",
    monthlyAnalysis: "Analyse par mois",
    allIntervenants: "Tous",
    allMonths: "Tous les mois",
    nbInvoices: "Factures",
    caTotal: "CA total",
    collected: "Encaissé",
    pending: "En attente",
    caGenerated: "CA total généré",
    caPaid: "CA encaissé",
  },
  billingPage: {
    title: "Facturation",
    subtitle: "Abonnement et historique de paiements.",
    currentPlan: "Abonnement actuel",
    invoiceHistory: "Historique des factures",
    noBillingInvoices: "Aucune facture d'abonnement.",
    downloadPdf: "PDF",
    downloadError: "Erreur de téléchargement",
    planActive: "Actif",
    planExpires: "Expire le",
    noSubscription: "Aucun abonnement actif.",
    noSubscriptionTitle: "Aucune souscription",
    noSubscriptionDesc: "Vous n'avez pas encore souscrit à un plan Hsasoft. Choisissez votre plan pour activer la facturation et continuer à utiliser HInvoice au-delà de votre période d'essai.",
    choosePlan: "Choisir un plan",
    cancelAtPeriodEnd: "Annuler à la fin de la période",
    cancelScheduled: "Annulation programmée pour le",
    perMonth: "/ mois",
  },

  auditPage: {
    title: "Journal d'audit",
    subtitle: "Historique des actions dans votre espace.",
    noEvents: "Aucun événement.",
    colDate: "Date",
    colUser: "Utilisateur",
    colAction: "Action",
    colResource: "Ressource",
  },
  reconciliationPage: {
    title: "Réconciliation",
    subtitle: "Associez vos paiements reçus aux factures.",
    noItems: "Aucun élément à réconcilier.",
    reconcile: "Réconcilier",
    ignore: "Ignorer",
  },
  uploadsPage: {
    title: "Factures reçues",
    subtitle: "Importez et analysez vos factures fournisseurs.",
    upload: "Importer",
    noUploads: "Aucune facture importée.",
    processing: "Traitement en cours…",
    colFile: "Fichier",
    colDate: "Date",
    colStatus: "Statut",
    colActions: "Actions",
  },
  reminderRulesPage: {
    title: "Règles de relance",
    subtitle: "Configurez vos relances automatiques.",
    newRule: "Nouvelle règle",
    noRules: "Aucune règle configurée.",
    deleteConfirm: "Supprimer cette règle ?",
    editRule: "Éditer la règle",
    colName: "Nom",
    colTrigger: "Déclencheur",
    colTemplate: "Template",
    colActive: "Actif",
  },
  reminderTemplatesPage: {
    title: "Templates de relance",
    subtitle: "Rédigez vos modèles d'emails de relance.",
    newTemplate: "Nouveau template",
    noTemplates: "Aucun template.",
    deleteConfirm: "Supprimer ce template ?",
    editTemplate: "Éditer le template",
    colName: "Nom",
    colSubject: "Sujet",
    colLang: "Langue",
  },
  trialBanner: {
    trialEnds: "Votre essai se termine le",
    subscribe: "S'abonner",
    expired: "Votre essai a expiré.",
  },
  loginPage: {
    title: "Connexion",
    email: "Email",
    password: "Mot de passe",
    submit: "Se connecter",
    loading: "Connexion…",
    noAccount: "Pas de compte ?",
    signup: "Créer un tenant",
  },
  signupPage: {
    title: "Créer un tenant",
    fullName: "Votre nom complet",
    email: "Email",
    password: "Mot de passe",
    passwordHint: "Minimum 10 caractères",
    companyLong: "Nom de l'entreprise",
    slug: "Slug (identifiant URL)",
    slugHint: "lettres, chiffres, tirets — ex : hsasoft",
    language: "Langue / Language",
    submit: "Créer le compte",
    loading: "Création…",
    haveAccount: "Déjà un compte ?",
    login: "Se connecter",
    trialHint: "Vous démarrez un essai de 14 jours. Vous pourrez passer au plan {{plan}} à tout moment depuis la page tarifs.",
    errorDefault: "Échec de la création du compte",
  },

  uploadsPage: {
    title: "Factures reçues",
    subtitle: "Uploade un PDF, laisse l'OCR extraire les champs, puis valide.",
    upload: "Importer un PDF",
    tabReview: "À revoir",
    tabProcessing: "En cours",
    tabErrors: "Erreurs",
    tabValidated: "Validés",
    colFile: "Fichier",
    colSize: "Taille",
    colDate: "Reçu le",
    noUploads: "Aucune facture importée.",
    processing: "Traitement…",
  },
  reconciliationPage: {
    title: "Réconciliation bancaire",
    subtitle: "Importez un relevé bancaire CSV, associez chaque ligne créditrice à une facture.",
    importCsv: "Importer un CSV",
    formats: "Formats : Banque FR (Libellé, Montant) ou EN (Label, Amount). Débits ignorés.",
    reconcile: "Réconcilier",
    ignore: "Ignorer",
    noItems: "Aucun élément à réconcilier.",
  },
  membersPage: {
    title: "Équipe",
    subtitle: "Gère les membres de ce tenant. Au moins un administrateur doit rester en place.",
    invite: "Inviter un membre",
    joinedAt: "Rejoint le",
    lastLogin: "Dernière connexion",
    you: "vous",
    remove: "Retirer",
    pendingTitle: "Invitations en attente",
    pendingDesc: "Le destinataire reçoit un email avec un lien valable 7 jours.",
    noPending: "Aucune invitation en attente.",
    roleAdmin: "Administrateur",
    roleMember: "Membre",
  
    accepted: "Accepté",
    hintAdmin: "Accès complet, gestion des membres",
    hintComptable: "Factures, paiements, relances",
    hintViewer: "Lecture seule",
    inviteRole: "Rôle",
    proposedRole: "Rôle proposé",
    inviteSent: "Invitation envoyée à",
    deleteConfirm: "Retirer ce membre ?",
    roleViewer: "Observateur",
    revokeConfirm: "Annuler l'invitation de {email} ?",
    noMembers: "Aucun membre.",
    roleComptable: "Comptable",
    pending: "En attente",
    inviteEmail: "Email",
    colName: "Nom",
    colRole: "Role",
    colJoined: "Rejoint le",
    colLastLogin: "Derniere connexion",
    colSent: "Envoyee le",
    colExpiry: "Expiration",
    expiresInDays: "expire dans {n} j",
    expiresInHours: "expire dans {n} h",
    expired: "expiree",
    expiresSoon: "bientot",
  },
  reminderRulesPage: {
    title: "Règles de relance",
    subtitle: "Configurez quand et comment relancer vos clients.",
    newRule: "Nouvelle règle",
    editRule: "Éditer la règle",
    noRules: "Aucune règle configurée.",
    colTrigger: "Déclenchement",
    colTemplate: "Template",
    colOrder: "Ordre",
    colActive: "Activée",
    deleteConfirm: "Supprimer cette règle ?",
  },
  reminderTemplatesPage: {
    title: "Templates de relance",
    subtitle: "Personnalisez les emails de relance envoyés automatiquement.",
    newTemplate: "Nouveau template",
    editTemplate: "Éditer le template",
    noTemplates: "Aucun template.",
    deleteConfirm: "Supprimer ce template ?",
    emailSubject: "Objet de l'email",
    emailBody: "Corps (texte)",
    key: "Clé",
  },
  suppliersPage: {
    title: "Fournisseurs",
    subtitle: "Dépenses et factures fournisseurs",
    chartTitle: "Dépenses par fournisseur",
    searchPlaceholder: "Rechercher une facture fournisseur…",
    noInvoices: "Aucune facture fournisseur. Importez un PDF avec le type \"Fournisseur\".",
    supplier: "Fournisseur",
    colRef: "Référence",
    colDate: "Date",
    colDue: "Échéance",
    colTtc: "TTC",
    colStatus: "Statut",
  },
  salesPage: {
    title: "Ventes",
    subtitle: "Gérez vos devis et offres commerciales.",
    newQuote: "Nouveau devis",
    colRef: "Référence",
    colClient: "Client",
    colIntervenant: "Intervenant",
    colAmount: "Montant TTC",
    colExpiry: "Expiration",
    colStatus: "Statut",
    allStatuses: "Tous les statuts",
    statusDraft: "Brouillon",
    statusSent: "Envoyé",
    statusAccepted: "Accepté",
    statusDeclined: "Refusé",
    statusCancelled: "Annulé",
    statusInvoiced: "Facturé",
    editQuote: "Modifier le devis",
    createQuote: "Nouveau devis",
    client: "Client",
    intervenant: "Intervenant",
    issueDate: "Date d'émission",
    expiryDate: "Date d'expiration",
    paymentTerms: "Conditions de paiement",
    notes: "Notes",
    lines: "Lignes",
    lineDescription: "Description",
    lineQty: "Qté",
    lineUnitPrice: "Prix unitaire",
    lineVat: "TVA %",
    lineUnit: "Unité",
    lineAmountHT: "HT",
    addLine: "Ajouter une ligne",
    totalHT: "Total HT",
    totalVAT: "TVA",
    totalTTC: "Total TTC",
    send: "Envoyer",
    toInvoice: "Convertir en facture",
    sendConfirm: "Marquer ce devis comme envoyé ?",
    toInvoiceConfirm: "Créer une facture depuis ce devis ?",
    deleteConfirm: "Supprimer ce devis ?",
    invoiceCreated: "Facture créée avec succès",
    noQuotes: "Aucun devis pour l'instant.",
    selectClient: "Sélectionner un client",
    selectIntervenant: "Sélectionner un intervenant (optionnel)",
    downloadPdf: "Télécharger le PDF",
    ptSelect: "— Sélectionner —",
    pt0: "0 jour (paiement immédiat)",
    pt30: "30 jours",
    pt45: "45 jours",
    pt60: "60 jours",
    pt90: "90 jours",
    downloadPdfEn: "PDF EN",
    duplicate: "Dupliquer",
      project: "Projet",
      selectProject: "Sélectionner un projet (optionnel)",
      currency: "Devise",
      currencyHint: "EUR, AED ou USD",
      accept: "Accepter",
      decline: "Refuser",
      declineConfirm: "Marquer ce devis comme refusé ?",
    discountTitle: "Remise commerciale",
    discountType: "Type de remise",
    discountNone: "— Aucune remise —",
    discountPercent: "En pourcentage (%)",
    discountFixed: "En valeur fixe ({currency})",
    discountLabelPercent: "Remise (%)",
    discountLabelFixed: "Remise HT ({currency})",
    discountPlaceholderPercent: "ex: 10",
    discountPlaceholderFixed: "ex: 500",
    grossSubtotal: "Sous-total brut HT",
    discountLine: "Remise",
  },
  companySettings: {
    title: "Informations société",
    subtitle: "Ces informations apparaissent sur vos devis et factures.",
    identity: "Identité",
    companyName: "Nom de la société",
    email: "Email de contact",
    phone: "Téléphone",
    website: "Site web",
    address: "Adresse",
    addressLine1: "Adresse ligne 1",
    addressLine2: "Adresse ligne 2",
    postalCode: "Code postal",
    city: "Ville",
    country: "Pays",
    legal: "Informations légales",
    siret: "SIRET / Licence",
    vatNumber: "Numéro TVA / Tax",
    logo: "Logo",
    logoHint: "Format PNG, JPG ou SVG. Max 2 Mo.",
    changeLogo: "Changer le logo",
    bank: "Coordonnées bancaires",
    bankName: "Banque",
    iban: "IBAN",
    bic: "BIC / SWIFT",
    legalFooter: "Mentions légales",
    legalFooterHint: "Apparaît en bas des devis et factures.",
    saved: "Paramètres enregistrés.",
    saveError: "Erreur lors de la sauvegarde.",
    logoUploaded: "Logo mis à jour.",
    logoError: "Erreur lors de l'upload du logo.",
    defaultVatRate: "Taux TVA par défaut (%)",
    vatRateHint: "Ex : 5 pour les Émirats, 20 pour la France",
    currency: "Devise par défaut",
    currencyHint: "Appliquée aux nouvelles factures par défaut",
  },

  footer: {
    copyright: "Tous droits réservés.",
    legalLink: "Mentions légales",
    contact: "Contact",
  },
  legal: {
    title: "Mentions légales",
    subtitle: "HInvoice — édité par Hsasoft",
    editorTitle: "Éditeur du service",
    company: "Société",
    product: "Produit",
    licence: "Numéro de licence",
    address: "Adresse du siège",
    addressValue: "DIP Falcon House, Dubai, Émirats Arabes Unis",
    email: "Email de contact",
    hostingTitle: "Hébergement",
    hostingText: "HInvoice est hébergé sur des serveurs Hostinger VPS, exploités par Hostinger International Ltd., 61 Lordou Vironos Street, 6023 Larnaca, Chypre.",
    ipTitle: "Propriété intellectuelle",
    ipText: "L'ensemble des contenus présents sur HInvoice (textes, images, logos, interfaces, logiciels) sont la propriété exclusive de Hsasoft ou de ses partenaires, et sont protégés par les lois applicables en matière de propriété intellectuelle. Toute reproduction, distribution ou utilisation sans autorisation préalable est interdite.",
    dataTitle: "Données personnelles",
    dataText: "HInvoice collecte et traite des données personnelles dans le cadre de la fourniture du service (gestion de compte, facturation, envoi d'emails). Ces données sont conservées de manière sécurisée et ne sont jamais cédées à des tiers sans consentement explicite.",
    dataText2: "Conformément aux réglementations applicables, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits, contactez-nous à",
    liabilityTitle: "Limitation de responsabilité",
    liabilityText: "Hsasoft s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur HInvoice. Toutefois, Hsasoft ne saurait être tenu responsable des erreurs ou omissions, ni des dommages directs ou indirects résultant de l'utilisation du service.",
    lawTitle: "Droit applicable",
    lawText: "Les présentes mentions légales sont soumises au droit des Émirats Arabes Unis. Tout litige relatif à leur interprétation ou leur exécution relève de la compétence exclusive des tribunaux compétents de Dubai.",
    updated: "Dernière mise à jour : mai",
    backLink: "← Retour à l'application",
  },
  productsPage: {
    title: "Produits",
    subtitle: "Gérez votre catalogue de produits et services.",
    newProduct: "Nouveau produit",
    searchPlaceholder: "Rechercher par nom...",
    colRef: "Référence",
    colName: "Nom",
    colDescription: "Description",
    colSalePriceHT: "Prix vente HT",
    colVat: "TVA %",
    colSalePriceTTC: "Prix vente TTC",
    colPurchasePrice: "Prix achat",
    colCurrency: "Devise",
    colUnit: "Unité",
    colActions: "Actions",
    editProduct: "Modifier le produit",
    createProduct: "Nouveau produit",
    name: "Nom",
    reference: "Référence",
    description: "Description",
    salePriceHT: "Prix de vente HT",
    vatRate: "Taux TVA (%)",
    salePriceTTC: "Prix de vente TTC",
    purchasePrice: "Prix d'achat (optionnel)",
    currency: "Devise",
    unit: "Unité (ex : h, jour, pièce)",
    archive: "Archiver",
    archiveConfirm: "Archiver ce produit ?",
    noProducts: "Aucun produit pour l'instant.",
    addToQuote: "Ajouter un produit au devis",
    selectProduct: "Sélectionner un produit (optionnel)",
  },
} as const;

export default fr;
